<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner>
          <div class="ts-space-y-3">
            <div class="row">
              <div class="col-md-12">
                <Info v-model="model" :validate="errors" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <Detail v-model="model" :validate="errors" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 ts-flex ts-items-center ts-space-x-3 ts-justify-end">
                <ts-button @click.prevent="$router.push({ name: 'product-price-schema' })">{{ $t('cancel')
                }}</ts-button>
                <ts-button color="primary" outline :waiting="loading" @click.prevent="onSaveAddNew">{{
                  $t('save_add_new') }}</ts-button>
                <ts-button :waiting="loading" color="primary" @click.prevent="onSave">{{ $t('save') }}</ts-button>
              </div>
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import Info from './components/info.vue'
import Detail from './components/detail.vue'
import { Errors } from 'form-backend-validation'

export default {
  components: {
    Info,
    Detail
  },
  data() {
    return {
      loading: false,
      errors: new Errors(),
      model: {
        is_all_product: false,
        guest_level_id: null,
        increment_amount: null,
        increment_type: '%',
        product_list: []
      }
    }
  },
  created() { },
  computed: {
    ...mapState('restaurantSale/productPriceSchema', ['formViewDatas']),
  },
  methods: {
    ...mapActions('restaurantSale/productPriceSchema', ['getFormViewModel']),
    async getPreData() {
      this.loading = true
      await this.getFormViewModel({ index: undefined, params: {} })
      this.loading = false
    },
    onSave() {
      this.loading = true
      this.$store
        .dispatch('restaurantSale/productPriceSchema/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'product-price-schema' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async onSaveAddNew() {
      this.errors = new Errors()
      this.loading = true
      this.$store
        .dispatch('restaurantSale/productPriceSchema/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    clearInput() {
      this.model.is_all_product = null
      this.model.guest_level_id = null
      this.model.increment_amount = null
      this.model.increment_type = null
      this.model.product_list = []
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getPreData()
    })
  },
}
</script>